/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {compose, isEmpty} from 'ramda';

/**
 * The internal dependencies.
 */
import FlexRootWrapper from '../../components/general/flex-root';
import Header from '../../containers/dashboard/header';
import Bar from '../../containers/dashboard/bar';
import ShopGrid from '../../containers/dashboard/grid/shop';
import StockGrid from '../../containers/dashboard/grid/stock';
import WorkinGrid from '../../containers/dashboard/grid/working';
import QualityGrid from '../../containers/dashboard/grid/quality';
import DisponentGrid from '../../containers/dashboard/grid/disponent';
import DoneGrid from '../../containers/dashboard/grid/done';
import {tasksRequest} from '../../store/tasks/actions';
import {getTasksItems} from '../../store/tasks/selectors';
import {tasksStepsRequest, tasksWorkStepsRequest} from "../../store/tasks/actions";


const RootWrapper = styled(FlexRootWrapper)`
	min-height: 100vh;
`;

const containers = {
    shop: ShopGrid,
    stock: StockGrid,
    working: WorkinGrid,
    quality: QualityGrid,
    disponent: DisponentGrid,
    done: DoneGrid,

};

class Dashboard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {container: null}
    }

    componentDidMount() {
        const {
            tasks,
            tasksRequest,
            tasksStepsRequest,
            tasksWorkStepsRequest
        } = this.props;

        if (isEmpty(tasks)) {
            tasksRequest();
        }

        tasksStepsRequest();
        tasksWorkStepsRequest();
    }

    componentDidUpdate(oldProps) {
        if (oldProps.location.pathname === this.props.location.pathname && this.state.container) {
            return;
        }

        this.determineCurrentContainer();
    }

    determineCurrentContainer() {
        const {location, history} = this.props;

        const current = location.pathname.replace('/dashboard/', '');

        if (!current) {
            history.replace(`${location.pathname}shop`);
        }

        this.setState({container: containers[current]});
    }

    render() {
        setTimeout(() => {
            if (!this.state.container) {
                this.determineCurrentContainer();
            }
        }, 100);

        const Container = this.state.container;
        return (
            <RootWrapper>
                <Header/>
                <Bar/>
                {Container && <Container/>}
            </RootWrapper>
        );
    }
}

export default compose(
    withRouter,
    connect(
        (state) => ({
            tasks: getTasksItems(state),
        }), {
            tasksRequest,
            tasksStepsRequest,
            tasksWorkStepsRequest
        }
    )
)(Dashboard);



// WEBPACK FOOTER //
// ./src/pages/dashboard/index.js